import { createSelector } from 'reselect';

export const getMeta = state => state.duplicates.meta;
export const getDuplicateGroups = state => state.duplicates.groups;
export const getDuplicatePeople = state => state.duplicates.people;
export const getDuplicateCompanies = state => state.duplicates.companies;
export const isDuplicateViewActive = state => state.duplicates.viewActive;
export const isLoading = state => state.duplicates.isLoading;

export const getPeopleMeta = state => getMeta(state).people;
export const getDuplicatePeopleCount = state => getPeopleMeta(state).totalCount;
export const getDuplicatePeoplePage = state => getPeopleMeta(state).currentPage;
export const getDuplicatePeoplePageSize = state => getPeopleMeta(state).pageSize;

export const getCompaniesMeta = state => getMeta(state).companies;
export const getDuplicateCompaniesCount = state => getCompaniesMeta(state).totalCount;
export const getDuplicateCompaniesPage = state => getCompaniesMeta(state).currentPage;
export const getDuplicateCompaniesPageSize = state => getCompaniesMeta(state).pageSize;

export const getDuplicatePeoplePageCount = createSelector(
  [getDuplicatePeopleCount, getDuplicatePeoplePageSize],
  (count, pageSize) => pageSize ? Math.ceil(count / pageSize) : 0
);

export const getDuplicateCompaniesPageCount = createSelector(
  [getDuplicateCompaniesCount, getDuplicateCompaniesPageSize],
  (count, pageSize) => pageSize ? Math.ceil(count / pageSize) : 0
);
